import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { tokens } from "../../../theme";
import {
  DateOnlyFormatter,
  DecimalToPercent,
  NairaFormatter,
} from "../../../helpers/formatters";
import { observer } from "mobx-react-lite";
import { ProjectModel } from "../../../api/models/project";
import Tag from "../../shared/tag/Tag";
import { PlainOutlinedButton } from "../../shared/buttons";
import { useNavigate } from "react-router-dom";
import { ROUTES1 } from "../../../routes";

interface Props {
  data: ProjectModel[];
}

const columns = [
  "Project Name",
  "Amount",
  "Rate",
  "No. of Trucks",
  "Closing",
  "Status",
  "Action",
];

export default observer(function ProjectsTable({ data }: Props) {
  const colors = tokens();
  const navigate = useNavigate();

  const handleViewProjectClick = (project: ProjectModel) => {
    navigate(`${ROUTES1.projects}/${project.id}`);
  };

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow
              sx={{
                "& .MuiTableCell-head": {
                  color: `${colors.grey[600]}`,
                  fontWeight: "bolder",
                },
              }}
            >
              {columns.map((column, index) => (
                <TableCell key={index} align="center">
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                  <TableCell align="center">{row.projectSource}</TableCell>
                  <TableCell align="center">
                    {NairaFormatter(row.amountPerUnit)}
                  </TableCell>
                  <TableCell align="center">
                    {DecimalToPercent(row.roiPercent)}
                  </TableCell>
                  <TableCell align="center">{row.numOfTruckLeft}</TableCell>
                  <TableCell align="center">
                    {DateOnlyFormatter(row.endDate)}
                  </TableCell>
                  <TableCell align="center">
                    <Tag text="Active" status="success" />
                  </TableCell>
                  <TableCell align="center">
                    <PlainOutlinedButton
                      title="View"
                      actionCallback={() => handleViewProjectClick(row)}
                      color="primary"
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
});
